import { disableTurbolinksForHrefsWithAnchorTags } from "./setup"

export function start() {
  disableTurbolinksForHrefsWithAnchorTags();
}